import { DENTAL_INSURANCE_SPECIALTIES } from '@zocdoc/components/src/constants';

export default function isADentistrySpecialty(specialtyId) {
    return DENTAL_INSURANCE_SPECIALTIES.has(specialtyId);
}
